import React from 'react';
import './VideoShowcase.css';

const VIDEO_URL = 'https://d3h5y5lv9ri89u.cloudfront.net/landing/website+video.mp4';

const VideoShowcase = () => {
    return (
        <div className="video-showcase">
            <video
                className="video-showcase__video"
                src={VIDEO_URL}
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                disablePictureInPicture
                aria-hidden="true"
                tabIndex={-1}
            />
        </div>
    );
};

export default VideoShowcase;
